'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface CategoryFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryFilter({
  categories,
  activeCategory,
  onCategoryChange
}: CategoryFilterProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  if (!isHydrated) {
    return (
      <div className="flex flex-wrap gap-2">
        {categories.map((_, index) => (
          <div key={index} className="h-10 w-32 bg-muted rounded-lg"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={`px-4 py-2 rounded-lg font-medium text-sm transition-all duration-300 flex items-center gap-2 ${
            activeCategory === category
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'bg-surface text-foreground hover:bg-muted'
          }`}
        >
          {category === 'Tous' && <Icon name="Squares2X2Icon" size={18} />}
          {category === 'Nettoyage' && <Icon name="SparklesIcon" size={18} />}
          {category === 'Résidentiel' && <Icon name="HomeIcon" size={18} />}
          {category === 'Conciergerie' && <Icon name="BuildingOfficeIcon" size={18} />}
          {category === 'Spécialisé' && <Icon name="WrenchScrewdriverIcon" size={18} />}
          {category === 'Multi-services' && <Icon name="CubeIcon" size={18} />}
          {category}
        </button>
      ))}
    </div>
  );
}